import { apiPost } from '../../../utils/api';

export const registerInternalUser = (email, roles, isSuperuser = false) => {
  return apiPost('/internal_users', 'register_internal_user', {
    email,
    adm_roles: roles,
    is_superuser: isSuperuser,
  });
};
